// removed by extract-text-webpack-plugin
module.exports = {"content":"personal__content-34rYU blocks__content--MOaB","user":"personal__user-Iux77"};


//////////////////
// WEBPACK FOOTER
// ./components/personal/personal.css
// module id = 852
// module chunks = 0